import { editPricingOfAccountEmailValidationCampaign, getPricingOfAccountEmailValidationCampaign } from "../types/account_campaign_pricing_email_validation_types";

export const getPricingOfAccountEmailValidationCampaignRequest = (payload, cb) => ({
  type: getPricingOfAccountEmailValidationCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_REQUEST,
  payload,
  cb,
});
export const getPricingOfAccountEmailValidationCampaignSuccess = (payload) => ({
  type: getPricingOfAccountEmailValidationCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_SUCCESS,
  payload,
});
export const getPricingOfAccountEmailValidationCampaignError = (payload) => ({
  type: getPricingOfAccountEmailValidationCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_ERROR,
  payload,
});

export const editPricingOfAccountEmailValidationCampaignRequest = (payload, cb) => ({
  type: editPricingOfAccountEmailValidationCampaign.EDIT_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_REQUEST,
  payload,
  cb,
});
export const editPricingOfAccountEmailValidationCampaignSuccess = (payload) => ({
  type: editPricingOfAccountEmailValidationCampaign.EDIT_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_SUCCESS,
  payload,
});
export const editPricingOfAccountEmailValidationCampaignError = (payload) => ({
  type: editPricingOfAccountEmailValidationCampaign.EDIT_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_ERROR,
  payload,
});
